import { Head } from '@inertiajs/inertia-vue3'
import MainLayout from '@/layouts/main.vue'
import ButtonGroup from '@/components/button-group.vue'

export default {
  components: {
    Head,
    MainLayout,
    ButtonGroup,
  },
}
